// extracted by mini-css-extract-plugin
export default {"captchaContainer":"Captcha--captchaContainer--5327cd","errorMessage":"Captcha--errorMessage--b81e99"};